/* eslint-disable @angular-eslint/no-input-rename */
import { AlertController, NavController } from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
import { CONFIG } from '../services/app-config.service';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  Input,
} from '@angular/core';
//
import { GlobalVariable } from '../../app/global';
// import { Geolocation } from '@ionic-native/geolocation/ngx';
import {
  NativeGeocoder,
  NativeGeocoderOptions,
  NativeGeocoderResult,
} from '@ionic-native/native-geocoder/ngx';
import { LocalStorageService } from '../services/core/local-storage.service';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { BranchDetailsPage } from '../branch-details/branch-details.page';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Router } from '@angular/router';
declare let google;
@Component({
  selector: 'app-select-branch',
  templateUrl: './select-branch.page.html',
  styleUrls: ['./select-branch.page.scss'],
})
export class SelectBranchPage implements OnInit {
  @ViewChild('map') mapElement: ElementRef;
  @Input('ismodal') ismodal;
  longitude: number;
  latitude: number;
  map: any;
  geocoder = new google.maps.Geocoder();
  userAddress: any;
  accuracy: number;
  geoencoderOptions: NativeGeocoderOptions = {
    useLocale: true,
    maxResults: 8,
  };
  branches = [];
  branch: any;
  showButton = false;
  branchSelected = false;
  noBranches = false;
  links: any;
  constructor(
    public server: UserApiService,
    public globals: GlobalVariable,
    public nav: NavController,
    private geolocation: Geolocation,
    private modalController: ModalController,
    private alertController: AlertController,
    private aib: InAppBrowser,
    private router: Router
  ) {
    // this.modalController.dismiss();
    this.getUserlocation();
  }

  ngOnInit() {}
  close() {
    this.modalController.dismiss();
  }
  ionViewWillLeave() {
    // let id=localStorage.getItem('activeBranchid');
    // if(id!=null && id!='null'){
    //   CONFIG.business_id=id;
    //   this.globals.branch_enabled=0;
    // }
  }

  async confirmleave() {
    if (!this.branchSelected) {
      const alert = await this.alertController.create({
        header: 'Select a Store',
        message: 'Please Select a store first.',
        buttons: [
          // {
          //   text: 'CaUssncel',
          //   role: 'cancel',
          //   cssClass: 'secondary',
          //   handler: () => {
          //   }
          // },
          {
            text: 'Okay',
            handler: () => {
            },
          },
        ],
      });

      await alert.present();
    } else {
      this.saveBranch();
    }
  }

  getBranches() {
    // this.globals.branch_enabled=1;

    this.globals.loader();
    this.server.getBusinessBranches(this.globals.mycoordinates).subscribe(
      (res) => {
        this.globals.dismiss();
        if (res.status == 'true') {
          this.branches = res.results;
        } else {
          this.noBranches = true;
        }
      },
      (err) => {
        this.globals.dismiss();

      }
    );
  }

  getUserlocation() {
    this.geolocation
      .getCurrentPosition()
      .then((position) => {
        // this.addressSearch=false;
        this.globals.userlatitude = position.coords.latitude;
        this.globals.userlongitude = position.coords.longitude;
        this.accuracy = position.coords.accuracy;
        this.globals.mycoordinates =
          position.coords.latitude + ',' + position.coords.longitude;
        this.loadMap(this.globals.userlatitude, this.globals.userlongitude);
        this.getBranches();

        // this.reverseGeoCoding()
        // this.getGeoencoder(resp.coords.latitude, resp.coords.longitude);
        // this.loadMap();
      })
      .catch((error) => {
        this.loadMap(this.globals.latitude, this.globals.longitude);
        this.getBranches();

        this.globals.presentToast('Error getting user  location', 'middle');
        // alert('Error getting location' + JSON.stringify(error));
      });
  }
  preSelectCase(place) {
    if (this.globals.itemsInCart.length > 0) {
      if (this.globals.tempPlace.business_id == place.business_id) {
        this.select(place);
      } else {
        this.confirmCartClear(place);
      }
    } else {
      this.select(place);
    }
  }
  async confirmCartClear(place) {
    const alert = await this.alertController.create({
      header: 'Alert',
      message: 'Switching to another location will clear your cart',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.select(this.globals.tempPlace);
          },
        },
        {
          text: 'Yes Clear and Switch',
          handler: () => {
            this.select(place);
            this.globals.itemsInCart = [];
            this.globals.OrderType = 'pickup';
          },
        },
      ],
    });

    await alert.present();
  }
  select(place) {
    // this.globals.branch_enabled=0;


    this.globals.tempPlace = place;
    localStorage.setItem('activeBranchid', place.business_id);
    localStorage.setItem('activeBranch', JSON.stringify(place));
    if (this.globals.franchise_enabled == true) {
      //if franchise save selcetion
      localStorage.setItem('remember_branch', 'true');
    }


    this.globals.businessName = place.name;
    this.globals.businessData = place;
    this.globals.business_phone = place.phone;
    this.globals.bussinessId = place.business_id;
    //for branch
    CONFIG.business_id = place.business_id;
    //asda

    this.globals.business_address = place.address;
    this.globals.tip_enabled = place.tip_enabled;
    this.globals.schedule_enabled = place.schedule_enabled;
    this.globals.display_menu = place.display_menu;
    this.globals.selected_branch_name = place.name;
    this.globals.point_check = place.points_enabled;
    this.globals.punch_check = place.punches_enabled;
    this.globals.special_offer = place.special_offer;
    this.globals.events_enabled = place.events_enabled;
    this.globals.dineInEnabled = place.dine_in;

    this.globals.businessHost = place.marketing_url[0];
    //menu style
    this.globals.MenuStyle = place.menu_style;

    // this.globals.franchise_enabled=place.franchise_enabled;
    this.globals.b_type = place.b_type;
    this.globals.gallery_enabled = place.gallery_enabled;
    this.globals.giftcard_enabled = place.giftcard_enabled;
    this.globals.pickup = place.pickup;
    this.globals.latitude = place.latitude;
    this.globals.longitude = place.longitude;
    //new added
    this.globals.qrEnabled = place.app_qr;
    if (this.globals.qrEnabled == undefined) {
      this.globals.qrEnabled = true;
    }
    //new added
    this.globals.hours_operation = place.hours_operation;
    this.globals.b_logo = place.logo;
    this.globals.StripId = place.stripe_id;
    this.globals.order_instructions = place.instructions_enabled;
    this.globals.pickup_timing = place.pickup_timing;
    this.globals.delivery_timing = place.delivery_timing;
    //this.globals.business_username = place.username;
    this.globals.branchUsername = place.username;
    this.globals.estimated_time = place.delivery_time;
    this.globals.business_discount_count = parseInt(
      place.business_discount_count
    );
    this.globals.username = place.username;
    this.globals.bussinessId = place.business_id;
    this.globals.admin_stripe = place.admin_stripe_enabled;
    this.globals.pickupsetting = place.delivery_time;
    this.globals.tax = place.tax;
    this.globals.deliveryCharges = place.delivery_fee;
    this.globals.cardDeliveryFee = place.card_delivery_fee;
    this.globals.pickup_Time = place.pickup_time;
    this.globals.minimun_order = parseInt(place.minimum_order);
    this.globals.availed_discount_count = parseInt(
      place.customer_discount_availed_count
    );
    this.globals.paypalId = place.paypal_id;
    this.globals.Timing = place.hours_operation;
    this.globals.delivery_day = place.delivery_day;
    this.globals.authorize_enabled = place.authorize_enabled;
    this.globals.card_enabled = place.card_enabled;
    this.globals.admin_stripe_enabled = place.admin_stripe_enabled;
    this.globals.catering_enabled = place.catering_enabled;
    this.globals.catering_cart_enabled = place.catering_cart_enabled;
    this.globals.loyaltyEnabled = place.loyalty;
    this.globals.reservationEnabled = place.reservation;

    this.globals.giftcard_amount_limit = place.giftcard_limit;
    this.globals.business_type = place.business_type;
    this.globals.website = place.website;
    this.globals.ccFeeDisclaimer = place.ccFeeDisclaimer;
    this.globals.menu_ready = place.menu_ready;
    this.globals.specific_delivery_day = place.specific_delivery_day;
    this.globals.review_enabled = place.review_enabled;
    this.globals.appointment_enabled = place.appointment_enabled;
    this.globals.orders_enabled = place.orders_enabled;
    this.globals.BusinessDiscount = place.discount;

    // platform fee data;
    this.globals.platformFeeEnabled = place.platformFeeEnabled;
    this.globals.platformFeeAmount = place.platformFeeAmount;
    this.globals.platformFeeLabel = place.platformFeeLabel;
    // document.documentElement.style.setProperty('--ion-color-primary', this.globals.appColor);
    localStorage.setItem('branchBusinessId', this.globals.bussinessId);

    if (this.globals.pickup == '1') {
      this.globals.pickup = true;
    } else {
      this.globals.pickup = false;
    }
    if (place.delivery == '1') {
      this.globals.delivery = true;
    } else {
      this.globals.delivery = false;
    }
    if (place.cash_enabled == '1') {
      this.globals.cash_enabled = true;
    } else {
      this.globals.cash_enabled = false;
    }
    if (this.globals.pickup == '1') {
      this.globals.pickup = true;
    } else {
      this.globals.pickup = false;
    }
    if (place.delivery == '1') {
      this.globals.delivery = true;
    } else {
      this.globals.delivery = false;
    }

    // this.globals
    this.globals.presentToast('Please wait selecting branch..', 'middle');
    this.globals.superCategories = [];
    this.globals.Homecategories = [];
    // this.globals.itemsInCart=[];
    // this.loadMap( this.globals.latitude, this.globals.longitude  )
    this.loadBanner();
    //     if ( place.appColor) {
    //      this.globals.appColor =  place.appColor;
    //        document.documentElement.style.setProperty('--ion-color-primary', this.globals.appColor);
    //  }
    document.getElementById('title').innerHTML = place.name;
  }
  loadBanner() {
    const response = this.server.LoadBanners();
    response.subscribe(
      (data) => {
        this.globals.isDataLoaded = true;
        this.globals.banner_color = data.banner_color;
        this.globals.giftCard_color = data.gift_cards_color;
        this.globals.myRewards_color = data.my_rewards_color;
        this.globals.orderNow_color = data.order_now_color;
        this.globals.specialOffer_color = data.special_offer_color;
        this.globals.themeColor = data.theme_color;
        this.globals.cash_discount = data.cash_discount;
        this.globals.banners = data.data;
        this.globals.ring_image = data.ring_image;
        this.globals.cash_discount_enabled = data.cash_discount_enabled;
        this.globals.cash_discount_percentage = data.cash_discount_percentage;
        this.globals.cash_discount_value = data.cash_discount_value;
        this.globals.cash_discount = data.cash_discount;

        if (this.globals.themeColor) {
          this.globals.appColor = data.theme_color;

          document.documentElement.style.setProperty(
            '--ion-color-primary',
            this.globals.appColor
          );
        }
        //rotung
        if (this.ismodal) {
          //using as modal...
          this.modalController.dismiss(true);
        } else {
          //not using as modal

          if (this.globals.inWeb || this.globals.franchise_enabled == false) {
            //if web or corporate . will show order page. else show home page

            // this.nav.navigateRoot('/tabs/tabs/menu');
            if (this.globals.inWeb) {
              //if in web show order page
              this.router.navigate(['/order']);
            } else {
              this.router.navigate(['/tabs/tabs/menu']); //for app will show order page but in tabs
            }
          } else {
            //going to home if franchise
            this.nav.navigateRoot('/tabs/tabs/home');
          }
        }
      },
      (error) => {
        // let alert = this.alertCtrl.create({
        //     message: 'Seems like your Network is not providing service. Try recharging',
        //     buttons: ['OK']
        // })
        // alert.present();
      }
    );
  }
  rememberMyChoice(e) {
    this.globals.rememberBranch = e.detail.checked;
    localStorage.setItem(
      'remember_branch',
      JSON.stringify(this.globals.rememberBranch)
    );
  }
  loadMap(lat, lng) {
    this.longitude = lng;
    this.latitude = lat;
    const mapOptions = {
      center: {
        lat: this.latitude,
        lng: this.longitude,
      },
      fullscreenControlOptions: false,
      mapTypeControl: false,
      zoom: 15,
      streetViewControl: false,
      zoomControl: false,
      fullscreenControl: false,
      keyboardShortcuts: false,
      scrollwheel: false,
      scaleControl: false,
      draggable: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.addMarker(this.latitude, this.longitude);
  }
  addMarker(lat: number, lng: number) {
    const latLng = new google.maps.LatLng(lat, lng);
    const marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: latLng,
      draggable: true,
      //   icon: {
      //     path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      //     strokeColor: "#ffc409",
      //     scale: 5
      // },
    });

    const content = 'Me'; //add username here

    this.addInfoWindow(marker, content);
  }
  addInfoWindow(marker, content) {
    const infoWindow = new google.maps.InfoWindow({
      content,
    });

    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }
  setActive(branch, index) {
    this.branchSelected = true; //19/10
    this.showButton = true;
    this.branch = branch;
    this.loadMap(parseFloat(branch.latitude), parseFloat(branch.longitude));
    const item = document.querySelectorAll('.item');

    // let item
    item.forEach((i) => {
      i.classList.remove('active');
    });
    item[index].classList.add('active');
  }
  saveBranch() {
    // localStorage.setItem('remember_branch',save);
    this.select(this.branch);
  }
  async branchDetails(branch) {
    const modal = await this.modalController.create({
      component: BranchDetailsPage,
      componentProps: { branch },
      mode: 'ios',
      backdropDismiss: true,
      breakpoints: [0, 0.9, 1],
      initialBreakpoint: 0.9,
      handle: false,
    });
    modal.present();
  }

  getCategories() {
    // this.globals.isDataLoaded = false;
    console.log('calling','Select branch'+CONFIG.business_id);
    this.server.getCategories().subscribe(
      (res) => {
        //   this.loadingMenu=true;
        // setTimeout(() => {
        //   this.loadingMenu=false;

        // }, 3000);

        this.globals.scrollEvents = res.restaurant.app_menu;
        // this.globals.businessName=res.restaurant.name;
        // this.globals.businessId=res.restaurant.id;
        this.globals.superCategories = res.super_categories;
        this.globals.superCategories.forEach((supercategory) => {
          supercategory.isAvailabe = this.checkTiming(
            supercategory?.hours_operation
          );
          supercategory.categories.forEach((category) => {
            category.isAvailabe = this.checkTiming(category.timings);
            category.items.forEach((item) => {
              // item.background = this.getColor();
              item.isAvailabe = this.checkTiming(item?.item_timings);
            });
          });
        });
        if (this.globals.superCategories.length > 0) {
          this.globals.Homecategories =
            this.globals.superCategories[0]?.categories;

          this.globals.activeSuperCatID = this.globals.superCategories[0].id;

          //active segment purpose only
          if (this.globals.inWeb == true) {
            // this.globals.dismiss()
            this.nav.navigateRoot('/order');
          }
          this.time_change();
        }

      },
      (err) => {
        if (this.globals.inWeb == true) {
          this.globals.dismiss();
        }
        this.globals.isDataLoaded = true;
        this.globals.presentToast('Network Error, try again');
      }
    );
  }

  time_change() {
    const scheduled_time_ = localStorage.getItem('scheduled_time');
    if (scheduled_time_ && scheduled_time_ != 'undefined') {
      const response = this.server.date_convert(scheduled_time_);
      response.subscribe(
        (data) => {
          if (data.success == true) {
            this.globals.s_day = data.day_id + 1;
            this.globals.s_time = data.time;
          }
        },
        (error) => {
          this.globals.presentToast(
            'Something went wrong check your internet connection.'
          );
        }
      );
    } else {
    }
  }

  viewMenu() {
    if (this.links) {
      this.aib.create(this.links, '_system');
    } else {
      this.globals.presentToast('No Menu file found.', 'middle');
    }
  }
  getSocials(place) {
    if (place.marketing_url.length > 0) {
      this.globals.loader();
      this.server.getSocials(place.marketing_url[0]).subscribe(
        (res) => {
          this.globals.dismiss();
          if (res.status) {
            // this.viewMenu();
            if (res.files.length > 0) {this.links = res.files[0].link;}
            this.viewMenu();
          } else {
            this.globals.presentToast('No Menu file found.', 'middle');
          }
        },
        (err) => {
          this.globals.dismiss();
        }
      );
    } else {
      this.globals.presentToast('No Menu file found.', 'middle');
    }
  }

  checkTiming(Timing) {
    if (Timing) {
      const scheduled_time_ = localStorage.getItem('scheduled_time');
      let date: any;
      let time: any;
      let day: any;
      if (
        this.globals.order_time == 'schedule' &&
        scheduled_time_ &&
        scheduled_time_ != null
      ) {

        day = this.globals.s_day;
        time = this.globals.s_time;
      } else {
        date = new Date();
        day = date.getDay();
        time = date.getHours() + '.' + date.getMinutes();
      }

      if (day == 7) {
        day = 0;
      }

      const current_day = Timing[day];
      const n = current_day[0].indexOf('.');
      if (n != -1) {
        var res = current_day[0].split('.');
        current_day[0] = res[0] + '.' + '3';
      }
      const n1 = current_day[1].indexOf('.');
      if (n1 != -1) {
        var res = current_day[1].split('.');
        current_day[1] = res[0] + '.' + '3';
      }

      time = Number(time);
      if (current_day) {
        if (
          (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
          (Number(current_day[0]) <= time &&
            Number(current_day[1]) < Number(current_day[0]))
        ) {
          return true;
        } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
